import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Maps,
  ImageExport,
  MapsComponent,
  MapsModule,
  MapsTooltip,
  MapsTooltipService,
} from '@syncfusion/ej2-angular-maps';
import { italyMap } from '../../../../../../shared/italy-regions';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { GenerateNationalReportComponent } from '../generate-national-report/generate-national-report.component';
import { NtMedicineInterface } from '../../../../../../shared/interfaces/nt-medicine.interface';
import { WIDGET_LAYOUT } from '../../../../../../shared/interfaces/widgetLayout';
import { TOOLTIPS_NT } from '../../../../../../shared/data/tooltipsNT.data';
import PptxGenJS from 'pptxgenjs';

Maps.Inject(MapsTooltip, ImageExport);

// same coordinates used by the national report (heatmap slide with percentages)
const REGION_LABEL_COORDINATES: { [key: string]: { x: number; y: number } } = {
  Lombardia: { x: 1.74, y: 2.2 },
  Piemonte: { x: 1.35, y: 2.3 },
  "Valle D'Aosta": { x: 1.16, y: 2.05 },
  Liguria: { x: 1.5, y: 2.55 },
  'Friuli Venezia Giulia': { x: 2.43, y: 1.98 },
  Veneto: { x: 2.1, y: 2.14 },
  'Prov. Aut. di Bolzano': { x: 2.1, y: 1.7 },
  'Prov. Aut. di Trento': { x: 1.96, y: 1.98 },
  'Emilia-Romagna': { x: 1.99, y: 2.47 },
  Toscana: { x: 1.93, y: 2.75 },
  Marche: { x: 2.54, y: 2.79 },
  Umbria: { x: 2.3, y: 2.95 },
  Lazio: { x: 2.31, y: 3.26 },
  Abruzzo: { x: 2.67, y: 3.1 },
  Molise: { x: 2.83, y: 3.33 },
  Campania: { x: 2.78, y: 3.6 },
  Puglia: { x: 3.22, y: 3.45 },
  Calabria: { x: 3.075, y: 4.03 },
  Basilicata: { x: 3.08, y: 3.68 },
  Sicilia: { x: 2.7, y: 4.46 },
  Sardegna: { x: 1.48, y: 3.8 },
};

// default brand info in case of missing data (same as the national report)
const DEFAULT_MEDICINE_BRAND = {
  font: { title: 'Arial, sans-serif', subtitle: 'Helvetica, sans-serif' },
  colors: { title: '#141F58', subtitle: '#00CEBC', background: '#FFFFFF' },
  logo: { url: '', altText: 'Logo' },
};

@Component({
  selector: 'app-customizable-heatmap-open-to-market',
  imports: [CommonModule, MapsModule, GenerateNationalReportComponent],
  providers: [MapsTooltipService],
  templateUrl: './customizable-heatmap-open-to-market.component.html',
  styleUrl: './customizable-heatmap-open-to-market.component.css'
})
export class CustomizableHeatmapOpenToMarketComponent implements OnInit {
  @Input() heatmapColorStatus: string = '';
  @Output() closeModal = new EventEmitter<boolean>();

  isLoading: boolean = true;
  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;

  heatmapOpenToMarketData: NtPotentialRegionInterface[] = [];
  heatmapEconomiaData: NtPotentialRegionInterface[] = [];
  mergedData: any[] = [];
  isGenerateNationalPPTModuleOpen: boolean = false;
  isGeneratingSlide: boolean = false;

  customHeatmapData: NtPotentialRegionInterface[] = [];

  @Input() medicineInfoDataInCustom: NtMedicineInterface = {
    id: 0,
    businessName: '',
    creationDate: '',
    activeSubstance: '',
    therapeuticArea: '',
    therapeuticIndication: '',
    therapeuticIndicationAcronym: '',
    reimbursementClass: '',
    supplyClass: '',
    atc: '',
    aic: '',
    openToAccessType: '',
    medicineBrandInfo: {
      font: { title: '', subtitle: '' },
      colors: { title: '', subtitle: '', background: '' },
      logo: { url: '', altText: 'Logo' },
    },
    launched: false,
    imported: false,
    tags: [],
    active: false,
  };
  @Input() widgetsAvailableInCustom: WIDGET_LAYOUT[] = [];
  @Input() titleCardInCustom: string = '';

  @ViewChild('previewMap') public maps?: MapsComponent;
  @ViewChild('exportMap') public exportMap?: MapsComponent;
  private exportMapResolve?: (base64: string) => void;
  private exportMapReject?: (error: unknown) => void;
  // isMapExpanded: boolean = false;
  public layers: object[] = [{ shapeData: italyMap }];

  constructor(private dataService: DataService, private us: DmtUtilityService) {}

  ngOnInit() {
    this.getSessionVariables();

    this.dataService
      .getHeatmapInfo(this.companyId, this.medicineId, this.countryId)
      .subscribe((data: NtPotentialRegionInterface[]) => {
        this.heatmapOpenToMarketData = data;
        console.log('heatmapOpenToMarketData', this.heatmapOpenToMarketData);

        setTimeout(() => {
          this.dataService
            .getHeatmapinfoPossInEconomia(this.companyId, this.medicineId, this.countryId)
            .subscribe((data2: NtPotentialRegionInterface[]) => {
              this.heatmapEconomiaData = data2;
              console.log('heatmapEconomiaData', this.heatmapEconomiaData);
              this.buildMergedData();
              this.isLoading = false;
            });
        }, 1000);
      });
  }

  buildMergedData() {
    this.mergedData = [];

    for (let i = 0; i < this.heatmapOpenToMarketData.length; i++) {
      const market = this.heatmapOpenToMarketData[i];
      let valueEconomia = '-';
      let economiaAvailable = false;

      for (let j = 0; j < this.heatmapEconomiaData.length; j++) {
        if (this.heatmapEconomiaData[j].regionId === market.regionId) {
          valueEconomia = this.heatmapEconomiaData[j].percentage + '%';
          economiaAvailable = this.heatmapEconomiaData[j].inEconomia === true;
        }
      }

      let valueOpenToMarket = market.percentage + '%';
      let selected = 'openToMarket';

      if (market.inEconomia === true) {
        valueOpenToMarket = '0%';
        selected = 'economia';
      }

      if (!economiaAvailable) {
        selected = 'openToMarket';
      }

      this.mergedData.push({
        regionId: market.regionId,
        regionName: market.regionName,
        inEconomia: market.inEconomia,
        economiaAvailable: economiaAvailable,
        valueEconomia: valueEconomia,
        valueOpenToMarket: valueOpenToMarket,
        selected: selected
      });
    }

    this.mergedData.sort((a, b) => a.regionName.localeCompare(b.regionName));
    this.buildMapLayers();
  }

  selectValue(region: any, choice: string) {
    region.selected = choice;
    this.buildMapLayers();
  }

  /* toggleMap() {
    this.isMapExpanded = !this.isMapExpanded;
    if (this.isMapExpanded) {
      setTimeout(() => this.maps?.refresh(), 320);
    }
  }*/

  buildMapLayers() {
    const dataSource = this.mergedData.map((region) => {
      const raw = region.selected === 'economia' ? region.valueEconomia : region.valueOpenToMarket;
      const percentage = Math.min(parseFloat(raw) || 0, 100);
      const label =
        region.regionName === 'Prov. Aut. di Trento' ? 'PA Trento' :
        region.regionName === 'Prov. Aut. di Bolzano' ? 'PA Bolzano' :
        region.regionName;

      return {
        regionId: region.regionId,
        mapColorValue: percentage,
        tooltipText: `${label}: <br> ${percentage.toFixed(2)}%`,
      };
    });

    this.layers = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource,
        tooltipSettings: {
          visible: true,
          valuePath: 'tooltipText',
          textStyle: { size: '10px' },
        },
        shapeSettings: {
          border: {
            color: this.heatmapColorStatus === 'Red' ? '#FFFFFF' : '#162456',
            width: this.heatmapColorStatus === 'Red' ? 0.4 : 0.7,
          },
          colorValuePath: 'mapColorValue',
          colorMapping: this.getColorMapping(),
        },
      },
    ];

    setTimeout(() => this.maps?.refresh(), 50);
  }

  private buildCustomHeatmapData(): NtPotentialRegionInterface[] {
    return this.mergedData.map((region) => {
      const raw =
        region.selected === 'economia'
          ? region.valueEconomia
          : region.valueOpenToMarket;
      const percentage = Math.min(parseFloat(raw) || 0, 100);

      // we start with the original data from heatmapOpenToMarketData to preserve other properties
      const original = this.heatmapOpenToMarketData.find(
        (r) => r.regionId === region.regionId,
      );

      return {
        ...original,
        regionId: region.regionId,
        regionName: region.regionName,
        percentage: percentage.toFixed(2),
      } as NtPotentialRegionInterface;
    });
  }

  async generateSingleSlide() {
    if (this.isLoading || this.isGeneratingSlide) return;

    try {
      const heatmapData = this.buildCustomHeatmapData();
      const mapImage = await this.exportHeatmapImage();
      await this.buildSingleSlidePPT(heatmapData, mapImage);
    } catch (error) {
      console.error('Error during single slide generation:', error);
    } finally {
      this.isGeneratingSlide = false;
    }
  }

  // renders the off-screen export map
  private exportHeatmapImage(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.exportMapResolve = resolve;
      this.exportMapReject = reject;
      this.isGeneratingSlide = true;

      setTimeout(() => {
        if (this.exportMapReject === reject) {
          this.clearExportCallbacks();
          reject(new Error('Map export timed out.'));
        }
      }, 15000);
    });
  }

  onExportMapLoaded() {
    const resolve = this.exportMapResolve;
    const reject = this.exportMapReject;
    if (!resolve || !reject || !this.exportMap) return;
    this.clearExportCallbacks();

    const promise = this.exportMap.export('PNG', 'Maps', undefined, false);
    if (!promise) {
      reject(new Error('Export method did not return a promise.'));
      return;
    }

    promise
      .then((data: any) => this.resizeBase64(data, 600, 468))
      .then(resolve)
      .catch(reject);
  }

  private clearExportCallbacks() {
    this.exportMapResolve = undefined;
    this.exportMapReject = undefined;
  }

  private async buildSingleSlidePPT(
    heatmapData: NtPotentialRegionInterface[],
    mapImage: string,
  ): Promise<void> {
    const brand =
      JSON.parse(sessionStorage.getItem('brandMedicine') ?? 'null') ??
      DEFAULT_MEDICINE_BRAND;
    const medicineName =
      sessionStorage.getItem('businessName') ||
      this.medicineInfoDataInCustom.businessName ||
      '';
    // title from the widget name, subtitle from the heatmap open to market tooltip (id: 1)
    const widgetName =
      this.titleCardInCustom ||
      this.widgetsAvailableInCustom.find((w) => w.id === 1)?.name ||
      '';
    const tooltipText = TOOLTIPS_NT.find((t) => t.id === 1)?.text || '';
    const heatmapBar =
      this.heatmapColorStatus === 'White'
        ? './assets/img/heatmapBarWhite.png'
        : './assets/img/heatmapBar.png';

    const cellOptions = { fontSize: 6.5, fontFace: brand.font.title, color: '000000' };
    const tableRows: PptxGenJS.TableRow[] = heatmapData.map((item) => {
      const value = parseFloat(item.percentage);
      return [
        { text: this.formatRegionName(item.regionName ?? '-'), options: cellOptions },
        { text: isNaN(value) ? '-' : `${value.toFixed(2)}%`, options: cellOptions },
      ];
    });
    const half = Math.ceil(tableRows.length / 2);
    const leftTableRows = tableRows.slice(0, half);
    const rightTableRows = tableRows.slice(half);

    const pptx = new PptxGenJS();

    const addSlideHeader = (slide: PptxGenJS.Slide) => {
      slide.addText(medicineName.toUpperCase() || 'NOME FARMACO', {
        x: 0.5, y: 0.3, w: '90%', h: '8%',
        fontSize: 11, fontFace: brand.font.title,
        color: brand.colors.title, bold: true, align: 'left',
      });
      if (brand.logo?.url) {
        slide.addImage({ path: brand.logo.url, x: 9.2, y: 0.3, w: '4%', h: '6%' });
      }
      if (widgetName) {
        slide.addText(widgetName, {
          x: 0.5, y: 0.6, w: '70%', h: '8%',
          fontSize: 14, fontFace: brand.font.subtitle,
          color: brand.colors.subtitle, bold: true, align: 'left',
        });
      }
      slide.addText(tooltipText, {
        x: 0.5, y: 0.9, w: '93%', h: '8%',
        fontSize: 9.5, fontFace: brand.font.subtitle,
        color: '000000', bold: false, align: 'left',
      });
    };

    // SLIDE 1 - map + table
    const slideTable = pptx.addSlide();
    addSlideHeader(slideTable);
    slideTable.addImage({ data: mapImage, x: 0.2, y: 1.5, w: '45%', h: '65%' });
    slideTable.addImage({ path: heatmapBar, x: 1.2, y: 5.0 + 0.04, w: '27%', h: '5%' });

    const tableOptions: PptxGenJS.TableProps = {
      y: 1.5,
      colW: [1.5, 1.0],
      rowH: 0.3,
      valign: 'middle',
      bold: false,
      fontSize: 8,
      color: '204131',
      border: { pt: 1.25, color: 'F1F1F1' },
    };
    if (leftTableRows.length > 0) {
      slideTable.addTable(leftTableRows, { ...tableOptions, x: 4.2 });
    }
    if (rightTableRows.length > 0) {
      slideTable.addTable(rightTableRows, { ...tableOptions, x: 7.0 });
    }

    // SLIDE 2 - map with percentages
    const slidePercentages = pptx.addSlide();
    addSlideHeader(slidePercentages);

    const legendX = 0.558;
    const legendY = 1.2;
    slidePercentages.addText('*', {
      x: legendX, y: legendY + 0.05, w: 0.1, h: 0.2,
      fontSize: 7.5, color: 'FF0000', bold: true, align: 'left', valign: 'middle',
    });
    slidePercentages.addText('I valori indicati rappresentano le percentuali di apertura.', {
      x: legendX + 0.02, y: legendY, w: 8, h: 0.3,
      fontSize: 7, fontFace: brand.font.title, color: '000000',
      bold: false, align: 'left', valign: 'middle',
    });

    slidePercentages.addImage({ data: mapImage, x: 0.2, y: 1.6, w: '45%', h: '65%' });
    slidePercentages.addImage({ path: heatmapBar, x: 1.2, y: 5.1 + 0.04, w: '27%', h: '5%' });

    heatmapData.forEach((item) => {
      const coords = REGION_LABEL_COORDINATES[item.regionName];
      const p = Number(item.percentage);
      if (coords && item.percentage !== undefined && item.percentage !== null && !isNaN(p) && p !== 0) {
        slidePercentages.addText(String(item.percentage), {
          x: coords.x, y: coords.y, w: 0.22, h: 0.1,
          fontSize: 4.5, fontFace: brand.font.title, color: '000000',
          bold: true, align: 'center', valign: 'middle',
          fill: { color: 'FFFFFF' }, margin: 0, wrap: false,
        });
      }
    });

    slidePercentages.addText(
      [
        {
          text: 'Commenti:',
          options: { bold: true, color: brand.colors.subtitle, fontSize: 11 },
        },
        {
          text: '\nQui puoi scrivere i tuoi commenti.',
          options: { italic: true, color: '404040', fontSize: 9 },
        },
      ],
      {
        x: 4.6, y: 1.6, w: '50%', h: '50%',
        fontSize: 11, fontFace: brand.font.subtitle, color: '000000',
        bold: false, align: 'left', valign: 'top',
      },
    );

    await pptx.writeFile({ fileName: widgetName || 'Heatmap-Apertura-Ospedaliera' });
  }

  private formatRegionName(regionName: string): string {
    if (regionName === 'Prov. Aut. di Bolzano') return 'PA di Bolzano';
    if (regionName === 'Prov. Aut. di Trento') return 'PA di Trento';
    return regionName;
  }

  private resizeBase64(base64: string, targetW: number, targetH: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext('2d')!;
        const scale = Math.min(targetW / img.width, targetH / img.height);
        const scaledW = img.width * scale;
        const scaledH = img.height * scale;
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, targetW, targetH);
        ctx.drawImage(img, (targetW - scaledW) / 2, (targetH - scaledH) / 2, scaledW, scaledH);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = base64;
    });
  }

  private getColorMapping(): any[] {
    if (this.heatmapColorStatus === 'Red') {
      return [
        { from: 0, to: 0, color: '#c10007' },
        { from: 0.01, to: 8.33, color: '#dd3a3f' },
        { from: 8.34, to: 16.66, color: '#e95b43' },
        { from: 16.67, to: 24.99, color: '#f47938' },
        { from: 25.0, to: 33.32, color: '#fba63a' },
        { from: 33.33, to: 41.65, color: '#ffd04c' },
        { from: 41.66, to: 49.98, color: '#ffe84a' },
        { from: 49.99, to: 58.31, color: '#e4f042' },
        { from: 58.32, to: 66.64, color: '#c5e73c' },
        { from: 66.65, to: 74.97, color: '#9fdd38' },
        { from: 74.98, to: 83.3, color: '#7cca33' },
        { from: 83.31, to: 91.63, color: '#51b42f' },
        { from: 91.64, to: 94.99, color: '#2e9c2b' },
        { from: 95.0, to: 98.99, color: '#27982d' },
        { from: 99.0, to: 100, color: '#008236' },
      ];
    }
    return [
      { from: 0, to: 0, color: '#ffffff' },
      { from: 0.01, to: 8.33, color: '#f8f8f8' },
      { from: 8.34, to: 16.66, color: '#eaeaea' },
      { from: 16.67, to: 24.99, color: '#e0e0e0' },
      { from: 25.0, to: 33.32, color: '#d0d0b3' },
      { from: 33.33, to: 41.65, color: '#d0d09c' },
      { from: 41.66, to: 49.98, color: '#c4c44d' },
      { from: 49.99, to: 58.31, color: '#9fbf4d' },
      { from: 58.32, to: 66.64, color: '#7fb34d' },
      { from: 66.65, to: 74.97, color: '#60a34d' },
      { from: 74.98, to: 83.3, color: '#449E51' },
      { from: 83.31, to: 91.63, color: '#3C9841' },
      { from: 91.64, to: 94.99, color: '#43a047' },
      { from: 95.0, to: 98.99, color: '#399c44' },
      { from: 99.0, to: 100, color: '#008236' },
    ];
  }

  onCloseModal(status: boolean) {
    this.closeModal.emit(status);
  }

  getSessionVariables() {
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId', 1);
    this.companyId = this.us.getSessionVariableNumber('companyId', 0);
  }

  handleModalChange(value: boolean) {
    // at the click
    if (value) {
      this.customHeatmapData = this.buildCustomHeatmapData();
    }

    this.isGenerateNationalPPTModuleOpen = value;
    if (this.isGenerateNationalPPTModuleOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }
}